import React from "react";
import './style.scss';

export default function PageFooter() {
    return (
        <footer className="page-footer">
            <header>
                <img className="rememory" src={`${process.env.PUBLIC_URL}/images/footer/logo_re_memory.png`} alt="Re:Memory Multimedialne Historie Lokalne" />
            </header>
            <p>Program został zrealizowany przez Centrum Edukacji Obywatelskiej.<br />Program wspiera finansowo Fundacja EVZ Pamięć – Odpowiedzialność – Przyszłość. <br />Partnerem projektu jest Fundacja Gazety Wyborczej. Niniejszy materiał nie reprezentuje
stanowiska Fundacji EVZ. <br />Fundacja EVZ nie ponosi odpowiedzialności za jego treść.</p>
            <div className="col-4">
                <a href="https://ceo.org.pl/">
                    <img src={`${process.env.PUBLIC_URL}/images/footer/uczotwartosci.svg`} alt="Ucz Otwartości" />
                </a>
                <a href="https://ceo.org.pl/">
                    <img src={`${process.env.PUBLIC_URL}/images/footer/ceo.svg`} alt="Centrum Edukacji Obywatelskiej" />
                </a>
                <a href="#">
                    <img src={`${process.env.PUBLIC_URL}/images/footer/evz.jpg`} alt="EVZ Foundation" />
                </a>
                <a href="">
                    <img src={`${process.env.PUBLIC_URL}/images/footer/fgw.png`} alt="Fundacja Gazety Wyborczej" />
                </a>
            </div>
        </footer>
    )
}
